<template>
  <loading v-if="getAdminByIdLoading"></loading>
  <div v-else>
    <div class="u-radius-g u-position-relative" style="height: 100px">
      <div class="u-background-color-filtered" style="height: 60px"></div>
      <div
        style="top: 20px; left: 0; position: absolute; width: 100%"
        class="u-position-absolute u-display-flex u-align-items-center u-justify-content-center"
      >
        <avatar :text="getAdmin.fullname" size="lg" />
      </div>
    </div>
    <div class="u-margin-top-small u-text-align-center">
      <h5>{{ getAdmin.fullname }}</h5>
      <p class="u-color-muted">
        <small>{{ getAdmin.email }}</small>
      </p>
      <p class="u-color-muted">
        <small>{{ getAdmin.phoneNo }}</small>
      </p>
    </div>
  </div>
</template>

<script>
import Avatar from "../Base/Avatar.vue";
export default {
  components: {
    Avatar,
  },
  props: {
    adminId: {
      default: 0,
    },
  },
  computed: {
    getAdminById() {
      return this.$store.getters["getAdminById"];
    },
    getAdmin() {
      return this.$store.getters["getAdminById"](this.adminId);
    },
    getAdminByIdLoading() {
      return this.$store.getters["getAdminByIdLoading"];
    },
  },
  methods: {
    async GET_ADMIN(force = false) {
      await this.$store.dispatch("getAdminById", {
        id: this.adminId,
        force,
      });
    },
  },
  mounted() {
    this.GET_ADMIN();
  },
};
</script>

<style></style>
